
import React, {Component} from 'react'
import {Button,ButtonToolbar,DropdownButton,MenuItem,Nav,NavItem,Panel,Row,Col,FormControl,FormGroup,InputGroup,Tabs,Tab} from 'react-bootstrap'
import FontAwsome from 'react-fontawesome'
import {Box} from 'reactjs-admin-lte'
import SWTWageDataGrid from './SWTWageDataGrid'
import SWTPartDataGrid from './SWTPartDataGrid'
import WorkdocStore from '../../stores/WorkdocStore'
import {Checkbox} from 'react-icheck'
import ConfirmPopup from '../../component/element/ConfirmPopup'
import NewDocFormModal from './NewDocFormModal'
import DepositDocModal from 'view/so/DepositDocModal'
import PurchaseOrderDocFromWorkModal from 'view/po/PurchaseOrderDocFromWorkModal'
import SWTStockOutPopup from './SWTStockOutPopup';
import Moment from 'moment';
// import MakerepairsDoc from '../doc/MakerepairsDoc';
import IframeModal from '../../component/element/IframeModal'
var NotificationSystem = require('react-notification-system');

const docNameConst = {invoice:'ใบแจ้งหนี้',receipt:'ใบเสร็จรับเงิน',taxinvoice:'ใบกำกับภาษี',cashbill:'บิลเงินสด',makerepairs:'ใบสรุปซ่อม'}
const defaultDocMenu = [
  {func:'quotation',title:'ใบเสนอราคา'},
  {func:'divider',title:''},
  // {func:'deposit',title:'ใบมัดจำ'},
  // {func:'divider',title:''},
  {func:'invoice',title:'ใบแจ้งหนี้'},
  {func:'receipt',title:'ใบเสร็จรับเงิน'},
  {func:'taxinvoice',title:'ใบกำกับภาษี'},
  {func:'cashbill',title:'บิลเงินสด'},
  {func:'divider',title:''},
  {func:'exportstock',title:'ใบเบิกคลังสินค้า'},
  {func:'divider',title:''},
  {func:'purchaseorder',title:'ใบสั่งซื้อ'},
]          

const LOCK_EXPORT_CONFIG = {recordType:'lock_export',title:'สร้างรายการล็อกสินค้าในคลัง',saveButtonTitle:'ล็อกสต็อกและบันทึกรายการ',decreaseStockColumnTitle:'ล็อกสต็อก',remarkTitle:'ล็อกรายการสต๊อกโดยใบงานหมายเลข'}
const STOCK_OUT_CONFIG = {recordType:'export',title:'สร้างรายการเบิกคลังสินค้าในคลัง',saveButtonTitle:'ตัดสต็อกและบันทึกรายการ',decreaseStockColumnTitle:'ตัดสต็อก',remarkTitle:'ตัดรายการสต๊อกโดยใบงานหมายเลข'}


const DEFAULT_DAMAGE_CFG = {program_visible:false,wage_quantity_visible:false,
  part_cost_per_unit_visible:false,discount_visible:false,discount_sum_visible:false,part_first:false,
  service_code_visible:false,part_from_list_visible:false,part_from_list:[],init_no_of_wage:10,init_no_of_part:10,
  part_cost_require:false}
class SWTWorkDocDamageFasttrack extends Component {

  constructor(...args){
    super(...args)
    this.state = {showPartSup:(this.props.dn=='QuotationDoc'?true:false),loading:false,loadingPart:false,partTab:'',errorShow:false,showNewDoc:false,docName:'',showWage:true,program:null,activeTab:0,presentTab:0,history:[],
    damageCfg:DEFAULT_DAMAGE_CFG, showStockOut:false,showDpDoc:false,showPoDoc:false,
    dataStockOut:[], dataPartlist:[], dataWagelist:[], displayBtnStockOutView: "none", btnDisabled: false, discountPart:[0,''], discountWage:[0,''], curDiscountPart:[0,''], curDiscountWage:[0,''], checkDiscount:false, displayDiscount:"none",
    discount_part:0, discount_wage:0, discountShow:false,showMissPartCost:false,
    docMenu:defaultDocMenu,stockOutConfig:STOCK_OUT_CONFIG,partFromList:[{'title':'ค่าอะไหล่','name':'stock_genpart',partList:[]}]
    }    
    
  }

  componentDidMount(){
    // this.loadData()
  }

  setPartList(partList){
    let data = partList.map((item,index)=>{
      // let amount = item.price_per_unit * item.quantity
      return {bfId:item.bf_work_damage_id,rowNo:item.seq,itemnum:item.itemnum,productCode:item.productcode,
        detail:item.detail,quantity:item.quantity,costPerUnit:item.cost_per_unit,pricePerUnit:item.price_per_unit,
        discountPercent:item.discount_percent,discountAmount:item.discount_amount,amount:item.amount,
        exportStock:item.export_stock_flag,exportQuantity:item.export_quantity,partFrom:item.part_from}
    })
    return data
  }

  setWageList(wageList){    
    let data = wageList.map((item,index)=>{
      // let amount = item.price_per_unit * item.quantity
      return {bfId:item.bf_work_damage_id,rowNo:item.seq,itemcode:item.itemcode,servicecode:item.servicecode,
        detail:item.detail,quantity:item.quantity,pricePerUnit:item.price_per_unit,amount:item.amount,
        discountPercent:item.discount_percent,discountAmount:item.discount_amount}
    })
    return data
  }

  loadData(){
    this.setState({loadingPart:false,loading:true})
    let {displayDiscount,checkDiscount,discountWage,discountPart,partTab} = this.state
    let partFromList = [{'title':'ค่าอะไหล่','name':'stock_genpart',partList:[]}] 
    WorkdocStore.loadWorkdocFixingList(this.props.workNo,(result)=>{
       let history = (typeof result.data.history !=='undefined')?result.data.history:[]
       
       let damageCfg = (result.data.damage_config==null)?DEFAULT_DAMAGE_CFG:Object.assign(DEFAULT_DAMAGE_CFG,result.data.damage_config)
       // console.log('damageCfg',damageCfg)
       let presentTab = 0
       history.map((item,index)=>{
          if(item.work_no===this.props.workNo){
            presentTab = index
          }
       })

      history.push({
        work_no:"",
        work_date:"",
        mileage:"",
        htmlContent:""
      })

      if (result.data.discount_part>0||result.data.discount_wage>0) {
        displayDiscount = ""
        checkDiscount = true
        discountWage[0] = ""
        discountWage[1] = result.data.discount_wage
        discountPart[0] = ""
        discountPart[1] = result.data.discount_part
      }
      // console.log('onLoad',discountWage,discountPart)
      //let wageList = this.refs.wageDataGrid.setWageList(result.data.wagelist)
      

      if(damageCfg.part_from_list_visible){
        let {part_from_list} = damageCfg
        partFromList  = partFromList.concat(JSON.parse(JSON.stringify(part_from_list)))
        //[{title:'',name:'',list:[]},{title:'',name:'',list:[]}]      
        
        result.data.partlist.map((item,index)=>{
          let findex = partFromList.findIndex(o => o.name === item.part_from);          
          if(findex>=0){
            if(partFromList[findex].partList===undefined){
              partFromList[findex].partList = []
            }
            partFromList[findex].partList.push(item)
          }else{
            partFromList[0].partList.push(item)
          }          
          return item
        })
        
        //partFromList.unshift({'title':'ค่าอะไหล่','name':'stock_genpart',partList:partList})
        partFromList = partFromList.map((item,index)=>{
          if(item.partList!==undefined)
            item.partList =  this.setPartList(item.partList)
          else
            item.partList = []
          return item
        })
        
        partTab = 'tab-'+partFromList[0].name
        this.setState({partFromList:partFromList,partTab:partTab})
        
      }else{
         //this.refs.partDataGrid.setPartList(this.setPartList(result.data.partlist))
         
      }
      //console.log('partFromList',partFromList,partTab)
      let partList =  this.setPartList(result.data.partlist)
      let wageList =  this.setWageList(result.data.wagelist)
      let docMenu = (result.data.doc_menu!=undefined&&result.data.doc_menu.length!=0)?result.data.doc_menu:defaultDocMenu
      docMenu  = JSON.parse(JSON.stringify(docMenu))
      if(result.data.extra_doc_menu!==undefined ){
        result.data.extra_doc_menu.map((item,index)=>{
          let insertIndex = -1;
          docMenu.map((ditem,dindex)=>{
            if(ditem.title===item.position_title){
              //Match
              if(item.position==='after'){
                insertIndex = dindex+1
              }else if(item.position==='before'){
                insertIndex = dindex
              }
            }
          })
          if(insertIndex>0){
            docMenu.splice(insertIndex, 0, item)        
          }
        })
        
      }
      
       
      this.setState({checkDiscount:checkDiscount,displayDiscount:displayDiscount,discount_part:result.data.discount_part,                
        discount_wage:result.data.discount_wage,loadingPart:true,dataPartlist:partList,dataWagelist:wageList,loading:false,program:result.data.program,
        activeTab:presentTab,presentTab:presentTab,damageCfg:damageCfg,history:history,docMenu:docMenu}) 
      this.calculateDiscount(discountPart,discountWage,partList,wageList,'init') 
    },()=>{


    })
  }

  onSaveClick(){
    let {program,discountPart,discountWage,displayDiscount,checkDiscount,damageCfg,partFromList} = this.state
    let wageList = this.refs.wageDataGrid.getWageList()
    let partList = []
    if(damageCfg.part_from_list_visible){
      partFromList.map((item,index)=>{
        let list = this.refs['partDataGrid-'+item.name].getPartList(item.name)
        partList =  partList.concat(list)
        return item
      })      
    }else{
      partList = this.refs.partDataGrid.getPartList()
    }

    if(damageCfg.part_cost_per_unit_visible && damageCfg.part_cost_require){
      let found = partList.find(function(element) {
        return (element.description!=='' && element.costPerUnit*1===0)        
      });

      if(found){
        this.setState({showMissPartCost:true})
        return;
      }
    }

    this.setState({loading:true})    
    WorkdocStore.saveWorkdocFixingList(this.props.workNo,wageList,partList,program,discountPart[1],discountWage[1],(result)=>{
      
      if (result.data.discount_part>0||result.data.discount_wage>0) {
        displayDiscount = ""
        checkDiscount = true
      } else {
        displayDiscount = "none"
        checkDiscount = false
      }
      this.refs.notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'บันทึกข้อมูลเรียบร้อย',
        level: 'info',
        position: 'tc'
      });
      this.setState({loading:false,displayDiscount:displayDiscount,checkDiscount:checkDiscount})
    },(error)=>{
      this.setState({loading:false,errorShow:true})
    })

    
  }

  onConfirmSave(){
    this.setState({errorShow:false})
    this.onSaveClick()
  }

  onCloseClick(){
    // window.show_work_table();
    this.props.onDocClose()
  }

  onMenuItemSelect(index,event){
    // console.log("eventKey",eventKey,event)
    let {docMenu} = this.state
    let eventKey = docMenu[index].func
    
    let {workNo} = this.props
    if("quotation"===eventKey){
      window.request_quotation();   
    }else if("deposit"===eventKey){
      this.setState({showDpDoc:true})
    }else if("print_doc1"===eventKey){
      let paramWo = workNo
      if(docMenu[index].wo!==undefined){
        paramWo = docMenu[index].wo
      }
      let url = './pdf?wo=' + paramWo + '&file='+docMenu[index].doc
      if (process.env.NODE_ENV == "development") {
        url = 'https://demo2.bigfix.co/korat/pdf/?wo=' + paramWo + '&file='+docMenu[index].doc
      }
      this.refs.iframe.loadUrl(url) 
    }else if("print_doc"===eventKey){
      let url = './pdf/v2?wo=' + workNo + '&startPage='+docMenu[index].doc
            
      if (process.env.NODE_ENV == "development") {
        url = './?wo=' + workNo + '&startPage=' +docMenu[index].doc    
      }
      
      this.refs.iframe.loadUrl(url) 
    }else if([ "invoice", "receipt", "taxinvoice", "cashbill","makerepairs"].includes(eventKey)){
      //window.request_cash_bill();    
      //this.setState({showNewDoc:true}) 
      
      this.refs.newdoc.loadData({workNo:workNo,docType:eventKey,docName:docNameConst[eventKey],
          onRowClick:function(docNo){
          if (process.env.NODE_ENV == "development") {
            alert('show_cashbill_doc:'+docNo)
          }else{
            var fn = window['show_'+eventKey+'_doc'];          
            if (typeof fn === 'function') {              
                fn.apply(undefined, [docNo]);
            } 
          }
        },onNewDoc:function(filterType,priceOnListType){
          if (process.env.NODE_ENV == "development") {
            alert('onNewDoc:'+filterType+','+priceOnListType)
          }else{
            var fn = window['create_'+eventKey+'_doc'];          
            if (typeof fn === 'function') {              
                fn.apply(undefined, [workNo,filterType,priceOnListType]);
            }          
          }
        }
      })
    }else if("lock_export"==eventKey){
      this.export_stock(LOCK_EXPORT_CONFIG)  
  
    }else if("exportstock"===eventKey){ 
      // window.request_export_stock();

      this.export_stock(STOCK_OUT_CONFIG)  
    }else if("purchaseorder"===eventKey){
      // window.request_purchase();
      this.setState({showPoDoc:true})
      this.refs.poDocModal.callNewDoc(this.state.dataPartlist,this.props.workNo)
    }
  }

  export_stock(stockOutConfig){
    
    
    WorkdocStore.loadWorkdocFixingList(this.props.workNo,(result)=>{

      let data = []
      for (var i=0;i<result.data.partlist.length;i++) {
        if (result.data.partlist[i].stock_flag == "1") {
          data.push(result.data.partlist[i])
        }
      }

      const yTh = parseInt(Moment().format('YYYY')) + 543
      const date = Moment().format('L LT').replace(Moment().format('YYYY'), yTh);
      let export_stock_flag = []
      data.forEach(element => {
        if (element.export_stock_flag=="1" || element.export_stock_flag=="2") {
          export_stock_flag.push({
            itemnum: element.itemnum
          })
        }
      })
      let displayBtnStockOutView = "none"
      let btnDisabled = false
      if (export_stock_flag.length>0) { // export_stock_flag.length==data.length
        displayBtnStockOutView = "none"
      } 
      if (export_stock_flag.length==data.length) {
        displayBtnStockOutView = "none"
        btnDisabled = true
      }
      this.setState({ createDate:date, showStockOut:true,stockOutConfig:stockOutConfig, dataStockOut:data, displayBtnStockOutView:displayBtnStockOutView, btnDisabled:btnDisabled })  

    },()=>{

    })
  }

  request_makerepairs(eventKey){
        
    let {workNo} = this.props
    let that = this
    //Show table
    this.refs.newdoc.loadData({workNo:workNo,docType:'makerepairs',docName:docNameConst['makerepairs'],
        onRowClick:function(docNo){
          that.setState({showNewDoc:true,docNo:docNo})
      },onNewDoc:function(filterType,priceOnListType){
        //Do something new
        // console.log('onNewDoc',filterType,priceOnListType)
        that.setState({showNewDoc:true})
      }
    })
  }

  onStockOutDeleteClick(e) {
    let data = this.state.dataStockOut
    var key = ""

    for (var i = 0; i < this.state.dataStockOut.length; i++) {
      if (e == this.state.dataStockOut[i].itemnum) {
        key = i
      }
    }

    data.splice(key, 1)
    this.setState({ dataStockOut: data })
  }

  onStockOutCancelClick(e) {
    
  }  

  onStockOutCloseClick() {
    this.setState({ showStockOut: false })
  }

  onShowWageChange(value){
    this.setState({showWage:value})
  }
  onShowPartSupChange(value) {
    this.setState({showPartSup:value})
  }

  onProgramChange(wageList,partList,program){
    this.setState({program:program})

    let {partFromList,damageCfg} = this.state
    wageList = this.refs.wageDataGrid.setWageList(this.setWageList(wageList))
    if(damageCfg.part_from_list_visible){
      // console.log('program',wageList,partList)
      partFromList[0].partList = this.setPartList(partList)
      this.setState({partFromList:partFromList,loadingPart:false,loading:true})

      setTimeout(()=>{
        this.setState({loadingPart:true,loading:false})
      },500)
      //this.refs['partDataGrid-'+partFromList[0].name].setPartList(this.setPartList(partList))
    }else{
      partList = this.refs.partDataGrid.setPartList(this.setPartList(partList))
    }
    let {discountPart,discountWage,curDiscountPart,sumAmtWage,dataWagelist,dataPartlist} = this.state
    this.calculateDiscount(discountPart,discountWage,partList,wageList)
  }

  onSuccessExport(){
      this.loadData()
  }

  onTabSelect(index){
    let {history} = this.state
    this.setState({activeTab:index})

    if (index==history.length-1||index==0) {
      //this.setState({presentTab:index})      
    }

    let item = history[index]
    if(this.props.workNo !== item.work_no && item.htmlContent==''){
      this.setState({loading:true})
      let that = this
      
      WorkdocStore.loadWorkdocFixingListHtmlContent(item.work_no,function(result){
        history[index].htmlContent = result.data.htmlContent
        that.setState({loading:false,history:history})
      })
    }
  }

  renderDocMenu(){
    let {docMenu} = this.state
    let title = (<span><i className="fa  fa-edit"></i>&nbsp;สร้างเอกสาร</span>)
    
    return (
      <div className="margin box-tools pull-right">
      <ButtonToolbar>
        <DropdownButton id='split-doc-menu' bsStyle={'primary'} title={title}  onSelect={this.onMenuItemSelect.bind(this)}>
          {
            docMenu.map((item,index)=>(
              
                (item.func=='divider')?
                (<MenuItem key={index} divider />):
                (<MenuItem key={index} eventKey={index}><FontAwsome name='file-text-o' className='text-green'/>{item.title}</MenuItem>)
              
            ))
          }
          
        </DropdownButton>
      </ButtonToolbar>
      </div>
    )
  }

  renderDocMenu2(){
    return (
      <div className="margin box-tools pull-right">
        <div className="btn-group hide-when-done">
        <button type="button" className="btn btn-primary "><i className="fa  fa-edit"></i>&nbsp;สร้างเอกสาร</button>
        <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
        <span className="caret"></span>
        <span className="sr-only">Toggle Dropdown</span>
        </button>
        <ul className="dropdown-menu" role="menu">
        <li aria-disabled="true"><a href="#new_doc_quotation"><i className="fa  fa-file-text-o text-green"></i>ใบเสนอราคา</a></li>
        <li aria-disabled="true"><a href="#new_doc_invoice"><i className="fa  fa-file-text-o text-green"></i>ใบแจ้งหนี้</a></li>
        <li aria-disabled="true"><a href="#new_doc_receipt"><i className="fa  fa-file-text-o text-green"></i>ใบเสร็จรับเงิน</a></li>
        <li aria-disabled="true"><a href="#new_doc_tax_invoice"><i className="fa  fa-file-text-o text-green"></i>ใบกำกับภาษี</a></li>
        <li aria-disabled="true"><a href="#new_doc_cash_bill"><i className="fa  fa-file-text-o text-green"></i>บิลเงินสด</a></li>
        <li aria-disabled="true"><a href="#new_doc_export_stock"><i className="fa  fa-file-text-o text-green"></i>ใบเบิกคลังสินค้า</a></li>
        </ul>
        </div>
      </div>
    )
  }
  
  onSelectPartTab(e){
    this.setState({partTab:e})
  }


  onWageDataChange(data){
    this.setState({dataWagelist:data})
    //this.getDiscountWage(data)
    let {discountPart,discountWage,curDiscountPart,sumAmtWage,dataWagelist,dataPartlist} = this.state
    this.calculateDiscount(discountPart,discountWage,dataPartlist,data,'table')
  }

  onPartFromDataChange(index,data){
    let {partFromList} = this.state
    let partList = []
    partFromList[index].partList = data
    partFromList.map((item,index)=>{
      //partFromList.partList = this.refs['partDataGrid-'+item.name].getPartList(item.name)
      partList =  partList.concat(item.partList)
      return item
    })      
      
    this.setState({partFromList:partFromList})
    //this.getDiscountPart()
    let {discountPart,discountWage,curDiscountPart,sumAmtWage,dataWagelist} = this.state
    //this.setState({})
    this.calculateDiscount(discountPart,discountWage,partList,dataWagelist,'table')
  }

  onPartDataChange(data){
    this.setState({dataPartlist:data})
    //this.getDiscountPart(data)
    let {discountPart,discountWage,curDiscountPart,sumAmtWage,dataWagelist} = this.state
    this.calculateDiscount(discountPart,discountWage,data,dataWagelist,'table')
  }

  calculateDiscount(disPart,disWage,dataPartlist,dataWagelist,source=''){
    let sumAmtPart=0,sumAmtWage=0,totalBeforeDis=0,totalAfterDis = 0,netTotal=0;
    let discountPart=[0,0],discountWage=[0,0]
    dataPartlist.forEach(function(item,index) {
      let quantity = item.quantity===undefined?0:item.quantity*1
      let pricePerUnit = item.pricePerUnit===undefined?0:item.pricePerUnit*1
      let discountAmount = item.discountAmount===undefined?0:item.discountAmount*1

      sumAmtPart += (quantity*pricePerUnit)
      discountPart[1] += discountAmount      
    })
    dataWagelist.forEach(function(item,index) {
      let quantity = item.quantity===undefined?0:item.quantity*1
      let pricePerUnit = item.pricePerUnit===undefined?0:item.pricePerUnit*1
      let discountAmount = item.discountAmount===undefined?0:item.discountAmount*1

      sumAmtWage += (quantity*pricePerUnit)
      discountWage[1] += discountAmount      
    })
    //console.log('dis',discountPart,discountWage,disPart,disWage)
    if(discountPart[1]>0)
      discountPart[0] = ((discountPart[1]/sumAmtPart)*100).toFixed(2)

    if(discountWage[1]>0)
      discountWage[0] = ((discountWage[1]/sumAmtWage)*100).toFixed(2);

    if(disPart[1]> discountPart[1] && discountPart[1]>0 && source==='sum'){
      //Table more than sum
      this.setState({discountShow:true})
      return false
    }

    if(disWage[1]> discountWage[1] && discountWage[1]>0 && source==='sum'){
      //Table more than sum
      this.setState({discountShow:true})
      return false
    }
    
    if(discountPart[1]===0 && (source==='sum' || source==='init')){
      if(disPart[1]>0){
        discountPart[0] = ((disPart[1]/sumAmtPart)*100).toFixed(2)
        discountPart[1] = disPart[1]  
      }else if(disPart[0]>0){
        discountPart[0] = disPart[0]
        discountPart[1] = sumAmtPart*disPart[0]/100
      } 
    }

    if(discountWage[1]===0  && (source==='sum' || source==='init')){
      if(disWage[1]>0){
        discountWage[0] = ((disWage[1]/sumAmtWage)*100).toFixed(2)
        discountWage[1] = disWage[1]
      }else if(disWage[0]>0){
        discountWage[0] = disWage[0]
        discountWage[1] = sumAmtWage*disWage[0]/100        
      }
    }


    totalBeforeDis = sumAmtPart + sumAmtWage
    totalAfterDis = totalBeforeDis - discountPart[1] - discountWage[1]
    netTotal = totalAfterDis
    this.setState({discountPart:discountPart,discountWage:discountWage,sumAmtPart:sumAmtPart,sumAmtWage:sumAmtWage,totalAfterDis:totalAfterDis,totalBeforeDis:totalBeforeDis,netTotal:netTotal})

    return true
  }


  checkSumDiscountOpen(dataPartlist,dataWagelist,discountWage,discountPart) {    

    let discountWage_table = 0
    dataWagelist.forEach(function(item,index) {
      let discountAmount = 0
      if (item.discountAmount<=0||isNaN(item.discountAmount)==true) {
        discountAmount = 0
      } else {
        discountAmount = item.discountAmount
      }
      discountWage_table = parseFloat(discountWage_table)+parseFloat(discountAmount)
    })

    let discountPart_table = 0
    dataPartlist.forEach(function(item,index) {
      let discountAmount = 0
      if (item.discountAmount<=0||isNaN(item.discountAmount)==true) {
        discountAmount = 0
      } else {
        discountAmount = item.discountAmount
      }
      discountPart_table = parseFloat(discountPart_table)+parseFloat(discountAmount)
    })
    // console.log('onCheckDiscount',discountWage,discountPart)
    if (discountWage[1]>0 || discountPart[1]>0 || discountWage_table>0||discountPart_table>0) {
      this.setState({checkDiscount:true})
    } else {
      this.setState({checkDiscount:false})
    }
  }

  onDiscountPercentChange(table,e) {
    let {discountPart,discountWage,dataPartlist,dataWagelist} = this.state    
    let disPart = [0,0],disWage =[0,0]
    let val = e.target.value
    if(val.charAt(0)==='0'){
      val = val.substring(1, val.length)
    }
    if (table==='wage') {
      disWage[0] = val
      disWage[1] = ''
      this.calculateDiscount(discountPart,disWage,dataPartlist,dataWagelist,'sum')
    } else if (table==='part') {
      disPart[0] = val
      disPart[1] = ''      
      this.calculateDiscount(disPart,discountWage,dataPartlist,dataWagelist,'sum')
    }    
  }

  onDiscountAmountChange(table,e) {
    let {discountPart,discountWage,dataPartlist,dataWagelist} = this.state
    let disPart = [0,0],disWage =[0,0]

    if (table==='wage') {
      disWage[0] = ''
      disWage[1] = e.target.value
      this.calculateDiscount(discountPart,disWage,dataPartlist,dataWagelist,'sum')
    } else if (table==='part') {
      disPart[0] = ''
      disPart[1] = e.target.value
      this.calculateDiscount(disPart,discountWage,dataPartlist,dataWagelist,'sum')
    }
  }


  onCheckDiscountChange(e) {
    let {checkDiscount,displayDiscount,discountPart,discountWage,curDiscountPart,curDiscountWage} = this.state
    if (checkDiscount) {
      checkDiscount = false
      displayDiscount = "none"
      curDiscountPart = discountPart
      curDiscountWage = discountWage
      discountPart = [0,'']
      discountWage = [0,'']
    } else {
      checkDiscount = true
      displayDiscount = ""
      discountPart = curDiscountPart
      discountWage = curDiscountWage
      // discountPart = [0,'']
      // discountWage = [0,'']
    }
    this.setState({checkDiscount:checkDiscount,displayDiscount:displayDiscount,curDiscountPart:curDiscountPart,curDiscountWage:curDiscountWage,discountPart:discountPart,discountWage:discountWage})
  }

  renderSummary() {
    let {discountPart,discountWage,discount_wage,discount_part,sumAmtWage,sumAmtPart,totalBeforeDis,totalAfterDis,netTotal} = this.state
    return (
        <Col md={5} className="">
          <div className="">
            <table className='table table-doc-summary'>
                <tbody>
                  <tr>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>จำนวนเงินค่าแรง</td>
                    <td className="text-right" style={{width:'150px'}}>{parseFloat(sumAmtWage).toLocaleString(undefined, {minimumFractionDigits: 2})}&nbsp;&nbsp;&nbsp;บาท</td>
                  </tr>
                  <tr>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>จำนวนเงินค่าอะไหล่</td>
                    <td className="text-right" style={{width:'150px'}}>{parseFloat(sumAmtPart).toLocaleString(undefined, {minimumFractionDigits: 2})}&nbsp;&nbsp;&nbsp;บาท</td>
                  </tr>
                  <tr>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>ยอดรวม</td>
                    <td className="text-right" style={{width:'150px'}}>{parseFloat(totalBeforeDis).toLocaleString(undefined, {minimumFractionDigits: 2})}&nbsp;&nbsp;&nbsp;บาท</td>
                  </tr>
                  <tr>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>
                      <FormGroup>
                        <InputGroup>
                          <InputGroup.Addon style={{border:'none',color:'#333',fontSize:'16px',paddingLeft:'30px'}}>ส่วนลดค่าแรง</InputGroup.Addon>
                          <FormControl 
                            style={{borderRadius:'0',right:'5px',width:'80px'}}
                            type="text" 
                            className='text-right input-right'
                            value={discountWage[0]}
                            onChange={this.onDiscountPercentChange.bind(this,'wage')}
                          />
                          <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit',color:'#333',fontSize:'16px'}}>%</InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    </td>
                    <td className="text-right" style={{width:'150px'}}>
                      <FormGroup>
                        <InputGroup>
                          <FormControl 
                            style={{borderRadius:'0',right:'5px'}}
                            type="text" 
                            placeholder="x,xxx"
                            className='text-right'
                            value={discountWage[1]}
                            onChange={this.onDiscountAmountChange.bind(this,'wage')}
                          />
                          <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit',color:'#333',fontSize:'16px'}}>บาท</InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>
                      <FormGroup>
                        <InputGroup>
                          <InputGroup.Addon style={{border:'none',color:'#333',fontSize:'16px',paddingLeft:'30px'}}>ส่วนลดค่าอะไหล่</InputGroup.Addon>
                          <FormControl 
                            style={{borderRadius:'0',right:'5px',width:'80px'}}
                            type="text" 
                            className='text-right input-right'
                            value={discountPart[0]}
                            onChange={this.onDiscountPercentChange.bind(this,'part')}
                          />
                          <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit',color:'#333',fontSize:'16px'}}>%</InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    </td>
                    <td className="text-right" style={{width:'150px'}}>
                      <FormGroup>
                        <InputGroup>
                          <FormControl 
                            style={{borderRadius:'0',right:'5px'}}
                            type="text" 
                            placeholder="x,xxx"
                            className='text-right'
                            value={discountPart[1]}
                            onChange={this.onDiscountAmountChange.bind(this,'part')}
                          />
                          <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit',color:'#333',fontSize:'16px'}}>บาท</InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>ยอดรวมหลังหักส่วนลด</td>
                    <td className="text-right" style={{width:'150px'}}>{parseFloat(totalAfterDis).toLocaleString(undefined, {minimumFractionDigits: 2})}&nbsp;&nbsp;&nbsp;บาท</td>
                  </tr>
                  <tr>
                    <td className="text-right"></td>
                    <td className="bbr-b text-right" style={{width:'150px'}}><b>ยอดรวมสุทธิ</b></td>
                    <td className="bbr-b text-right" style={{width:'150px'}}>{parseFloat(netTotal).toLocaleString(undefined, {minimumFractionDigits: 2})}&nbsp;&nbsp;&nbsp;บาท</td>
                  </tr>
                </tbody>
              </table>
          </div>    
        </Col>   
    )
  }

  renderPresentWork(){
    let {loading,damageCfg,checkDiscount} = this.state
    return (        
      <Box loading={loading}>
        <Box.Header className='text-center'>
          <Box.Title>
            <FontAwsome name='warning' className='text-blue'/>&nbsp;รายการซ่อม/เปลี่ยน
          </Box.Title>
          {/*{this.renderDocMenu()}*/}
          {this.renderPresentWorkDocMenu()}
        </Box.Header>
        {this.renderPresentWorkBody()}        
        <Box.Footer>
          <div className='pull-right'>
                <div style={{display:(damageCfg.discount_sum_visible)?'inline-block':'none'}}>
                      <Checkbox
                        onChange={this.onCheckDiscountChange.bind(this)}
                        checked={checkDiscount}
                        checkboxClass="icheckbox_square-blue"
                        increaseArea="20%"
                        label={' มีส่วนลด'}
                      >
                      </Checkbox>
              </div>
                      &nbsp;
              <Button bsStyle={'primary'} 
                className='hide-when-done element-ready'
                onClick={this.onSaveClick.bind(this)}
              >
                <FontAwsome name='save'/>&nbsp;บันทึก
              </Button>
              &nbsp;
              <Button onClick={this.onCloseClick.bind(this)}><FontAwsome name='close'/>&nbsp;ปิดใบงาน</Button>            
          </div> 
        </Box.Footer>
      </Box>
    )
  }

  renderPresentWorkDocMenu() {
    let {presentTab,history} = this.state
    
    if (presentTab!=history.length-1) {
      return (
        this.renderDocMenu()
      )  
    }  
  }

  renderWageTable(){
    let {showWage,program,damageCfg,presentTab,activeTab,history,loadingPart,dataWagelist} = this.state
    let {workNo} = this.props

    let pgmName = (program!=null&&program!=undefined&&program.name!=null&&program.name!=undefined)?'โปรแกรม'+program.name:''
    return (
      <div>
        <div>
              <h4 className='text-center'><span style={{display:showWage?'inline-block':'none'}}>สรุปรายการค่าแรง {pgmName}</span>
                <div className='pull-right'>
                  <Checkbox 
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label={' ซ่อนรายการค่าแรง'}
                    checked={!showWage}
                    onChange={this.onShowWageChange.bind(this,!showWage)}
                  />
                </div>
              </h4>
            </div>
            <div style={{display:showWage?'block':'none'}}>
              <SWTWageDataGrid 
                ref={'wageDataGrid'} 
                show={loadingPart}
                wageList={dataWagelist}
                initNoOfRow={damageCfg.init_no_of_wage}                
                showServiceCode={damageCfg.service_code_visible} 
                showDiscount={damageCfg.discount_visible}
                showQuantity={damageCfg.wage_quantity_visible} 
                showProgramButton={damageCfg.program_visible} 
                onProgramChange={this.onProgramChange.bind(this)}
                onChange={this.onWageDataChange.bind(this)}
              />
            </div>
      </div>
    )
  }

  

  renderOtherPartTab(){
    let {showPartSup,damageCfg,partFromList,partTab,loadingPart} = this.state
    //console.log('partListChange',partFromList,partTab)
    return partFromList.map((item,index)=>(
            <Tab  key={index}
                  eventKey={'tab-'+item.name}
                  title={item.title}
                >
                <SWTPartDataGrid 
                  ref={'partDataGrid-'+item.name}    
                  show={loadingPart && partTab==='tab-'+item.name}    
                  name={item.name}                       
                  partList={item.partList}
                  initNoOfRow={damageCfg.init_no_of_part}
                  showPartSup={showPartSup}
                  showDiscount={damageCfg.discount_visible}
                  showCostPerUnit={damageCfg.part_cost_per_unit_visible}
                  partCostRequire={damageCfg.part_cost_require}
                  onChange={this.onPartFromDataChange.bind(this,index)}
                />
          </Tab>
    ))
  }

  renderPartTable(){
    let {showPartSup,loadingPart,showWage,program,damageCfg,presentTab,activeTab,history,partFromList,dataPartlist} = this.state
    let {workNo} = this.props

    let pgmName = (program!=null&&program!=undefined&&program.name!=null&&program.name!=undefined)?'โปรแกรม'+program.name:''

    if(damageCfg.part_from_list_visible && partFromList.length>0){
      return (
        
        <div>
            <h4 className='text-center'><span>สรุปรายการค่าอะไหล่ {pgmName}</span>
                <div className='pull-right'>
                  <Checkbox 
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label={' ซ่อนผู้จัดอะไหล่'}
                    checked={!showPartSup}
                    onChange={this.onShowPartSupChange.bind(this,!showPartSup)}
                  />
                </div>
            </h4>
            <Tabs 
              defaultActiveKey={'tab-'+partFromList[0].name} 
              animation={false} 
              id="noanim-tab-example"
              onSelect={this.onSelectPartTab.bind(this)}
            >                          
                {this.renderOtherPartTab()}                
              </Tabs>
              
        </div>
      )
    }else{
      return (
        <div>
              <h4 className='text-center'><span>สรุปรายการค่าอะไหล่ {pgmName}</span>
                <div className='pull-right'>
                  <Checkbox 
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label={' ซ่อนผู้จัดอะไหล่'}
                    checked={!showPartSup}
                    onChange={this.onShowPartSupChange.bind(this,!showPartSup)}
                  />
                </div>
              </h4>
              <SWTPartDataGrid 
                ref={'partDataGrid'}  
                name='partDataGrid' 
                show={loadingPart}               
                partList={dataPartlist}     
                initNoOfRow={damageCfg.init_no_of_part}         
                showPartSup={showPartSup}
                showDiscount={damageCfg.discount_visible}
                showCostPerUnit={damageCfg.part_cost_per_unit_visible}
                partCostRequire={damageCfg.part_cost_require}
                onChange={this.onPartDataChange.bind(this)}
              />
        </div>
      )
    }
  }

  renderPresentWorkBody() {
    let {showWage,program,damageCfg,presentTab,activeTab,history} = this.state
    let {workNo} = this.props

    let pgmName = (program!=null&&program!=undefined&&program.name!=null&&program.name!=undefined)?'โปรแกรม'+program.name:''
    if (damageCfg.part_first) {
      return(
          <Box.Body>
            {this.props.onRenderHeader()!=undefined?this.props.onRenderHeader():''}
            {this.renderPartTable()}
            {this.renderWageTable()}
            <Row style={{marginTop:'10px'}}>
              {this.props.onRenderRemark()!=undefined?this.props.onRenderRemark():''}
              <Col md={4}></Col>
              {this.state.displayDiscount=='none'?'':this.renderSummary()}
            </Row>
          </Box.Body>
      )
    } else {
      return(
          <Box.Body>
            {this.props.onRenderHeader()!=undefined?this.props.onRenderHeader():''}
            {this.renderWageTable()}
            {this.renderPartTable()}
            <Row style={{marginTop:'10px'}}>
              {this.props.onRenderRemark()!=undefined?this.props.onRenderRemark():''}
              <Col md={4}></Col>
              {this.state.displayDiscount=='none'?'':this.renderSummary()}
            </Row>
          </Box.Body>
      )
    }  
  }

  renderPastWork(){
    let {history,activeTab,presentTab,loading} = this.state
    let item = history[activeTab]
    if(presentTab!==activeTab){
    return (
      <Box loading={loading}>
        <Box.Header>
          <Box.Title><FontAwsome name='warning' className='text-blue'/>&nbsp;เลขกม. {item.mileage} รายการซ่อม</Box.Title>          
        </Box.Header>
        <Box.Body>
          <div>
            <Panel style={{marginBottom:'0px'}}><div dangerouslySetInnerHTML={{__html:history[activeTab].htmlContent}}></div></Panel>
          </div>        
        </Box.Body>
      </Box>
    )  
    }else{
      return (<div/>)
    }  
    
  }

  renderNavItem(item,index){
    if(item.work_no===this.props.workNo){
      return (<NavItem key={index} eventKey={index} >รายการใบงานนี้</NavItem>)
    }else{
      return (<NavItem key={index} eventKey={index} >{item.work_date}</NavItem>)
    }
  }

  renderHistoryTab(history){
    let {activeTab} = this.state
    return (
      <Nav bsStyle="tabs" activeKey={activeTab} onSelect={this.onTabSelect.bind(this)}>   
        <NavItem key={history.length-1} eventKey={history.length-1} style={{display:'none'}}>แจ้งซ่อมล่วงหน้า</NavItem>     
        {history.map((item,index)=>(
          this.renderNavItem(item,index)
        ))}
      </Nav>
    )
  }

  // renderDoc(){
  //   let {showNewDoc} = this.state
  //   return (
  //     <div style={{display:(showNewDoc)?'block':'none'}}>
  //         <MakerepairsDoc />
  //     </div>
  //   )
  // }

  onPoDocModalHide() {
    this.setState({showPoDoc:false})
  }

  render(){
    let {history,showDpDoc,showPoDoc,stockOutConfig,showMissPartCost,errorShow,showNewDoc,activeTab,presentTab,discountShow} = this.state
    
    return (
      <div>
        
        {/* <div style={{display:(history.length>0)?'block':'none'}}>
          {this.renderHistoryTab(history)}
        </div> */}
        {/* <div style={{display:(activeTab==presentTab)?'block':'none'}}> */}
          {this.renderPresentWork()}
        {/* </div> */}
        {/* <div style={{display:(activeTab!==presentTab)?'block':'none'}}>
          {this.renderPastWork()}
        </div> */}
        <DepositDocModal ref='depDoc' show={showDpDoc}
        workNo={this.props.workNo}
        onHide={()=>{this.setState({showDpDoc:false})}}/>
        <PurchaseOrderDocFromWorkModal 
          ref='poDocModal' 
          show={showPoDoc}
          onHide={this.onPoDocModalHide.bind(this)}
        />
        <SWTStockOutPopup
          stockType={'genpart'}
          config={stockOutConfig}
          onShow={this.state.showStockOut}
          onHide={this.onStockOutCloseClick.bind(this)}
          onDelete={this.onStockOutDeleteClick.bind(this)}
          onCancel={this.onStockOutCancelClick.bind(this)}
          onSuccessExport={this.onSuccessExport.bind(this)}
          data={this.state.dataStockOut}
          date={this.state.createDate}
          workNo={this.props.workNo}
          displayBtnStockOutView={this.state.displayBtnStockOutView}
          btnDisabled={this.state.btnDisabled}
        />          
        <NewDocFormModal ref='newdoc'/>                
        <NotificationSystem ref="notificationSystem" />
        <IframeModal ref='iframe'  title={'พิมพ์เอกสาร'} />
        <ConfirmPopup show={errorShow} 
        title='มีปัญหาในการบันทึกข้อมูล' 
        message='พบปัญหาอินเตอร์เน็ต ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่'
        confirmTitle='ลองใหม่อีกครั้ง'
        onConfirm={this.onConfirmSave.bind(this)}
        onHide={()=>{this.setState({errorShow:false})}}        
        />
        <ConfirmPopup show={discountShow} 
        title='แจ้งเตือน'
        message='ท่านได้ใส่ข้อมูลส่วนลดค่าแรงในตาราง เรียบร้อยแล้ว ถ้าต้องการแก้ไขข้อมูล ให้ลบส่วนลดในตาราง'
        onHide={()=>{this.setState({discountShow:false})}}        
        />
        <ConfirmPopup show={showMissPartCost} 
        title='แจ้งเตือน'
        message='ระบบไม่อนุญาติให้บันทึกข้อมูล ถ้าไม่ได้ใส่ข้อมูลต้นทุนอะไหล่'
        onHide={()=>{this.setState({showMissPartCost:false})}}        
        />
              
      </div>
    )
  }
}

SWTWorkDocDamageFasttrack.defaultProps = {
  dn: '',
  onRenderHeader:()=>{},
  onRenderRemark:()=>{}
}

export default SWTWorkDocDamageFasttrack;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTWorkDocDamageFasttrack.js